'use client';

import React, { useState } from 'react';
import Button from '../../UI/Button';
import withTranslation from '../../../hoc/Intl';
import { isAccountExists } from '../../../helpers/apiClient';
import A from '../../UI/A.client';

const validateUrl = (url) => {
    if (!url) return 'errorSubdomainRequired';
    if (!/^[0-9A-Za-z-]{2,}$/.test(url)) return 'errorSubdomainContainsInvalidCharacters';
    return null;
};

const Login = ({ i18n: { t } }) => {
    const [url, setUrl] = useState('');
    const [errorKey, setErrorKey] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);

        const trimmed = url.trim();
        const syncError = validateUrl(trimmed);
        if (syncError) {
            setErrorKey(syncError);
            setLoading(false);
            return;
        }

        try {
            const exists = await isAccountExists(trimmed);
            if (!exists) {
                setErrorKey('errorAccountNotFound');
                setLoading(false);
                return;
            }
            const form = e.target;
            form.submit();
        } catch {
            setErrorKey('errorAccountNotFound');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setUrl(e.target.value);
        if (errorKey) setErrorKey(null);
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-8 col-lg-5 mt-8 mb-10">
                <h1 className="mb-4">{t('title')}</h1>
                <form
                    action="/welcome/goto_url"
                    method="POST"
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <label className="form-label" htmlFor="url">
                        {t('inputLabel')}
                    </label>

                    <div className="input-group">
                        <input
                            id="url"
                            name="url"
                            type="text"
                            value={url}
                            required
                            readOnly={loading}
                            className={`form-control ${errorKey ? 'is-invalid' : ''}`}
                            onChange={handleChange}
                        />
                        <span className="input-group-text">.joinposter.com</span>
                        {errorKey && (
                            <div className="invalid-feedback">
                                {t(errorKey)}
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <A href="/reset-account-name">
                            <Button link type="button">
                                <span className="d-none d-sm-block">{t('forgotEmailLink')}</span>
                                <span className="d-sm-none">{t('forgotEmailLinkShort')}</span>
                            </Button>
                        </A>

                        <Button type="submit" inProgress={loading}>
                            {t('submit')}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default withTranslation(Login, 'pages/login');
